import { Component, input } from '@angular/core';
import { StyleguideModule } from '@app/app/shared/styleguide/styleguide.module';
import { LucideIconInput } from '@lucide/angular';
import { TranslocoModule } from '@ngneat/transloco';

export type EmptyStateSize = 'l' | 'm' | 's';

@Component({
  selector: 'ptl-v3-empty-state',
  standalone: true,
  imports: [StyleguideModule, TranslocoModule],
  templateUrl: './v3-empty-state.component.html',
  styleUrls: ['./v3-empty-state.component.scss'],
})
export class V3EmptyStateComponent {
  icon = input.required<LucideIconInput>();
  title = input.required<string>();
  description = input<string>();
  size = input<EmptyStateSize>('l');
  plain = input<boolean>(false);
}
